export const removeAllImgTags = /<img\s+.*?>/g;
export const removeHtmlTags = /<[^>]*>/g;
export const commentRegex = /data-id="(\d+)"/g;
export const dateRegex = /(\d{2})\s+(\w{3})\s+(\d{2})\s+-\s+(\d{2})\s+(\w{3})\s+(\d{2})/;
export const hasHtmlAnchorHref = /<a\s+href=/i;
export const EXPRESSION_REGEX = /\[([^\]]+)\]|\+|\-|\*|\/|\=/g;
export const OPERATOR_CHAR_REGEX = /[+\-*/=]/;
export const SCHEDULE_SUFFIX_REGEX = new RegExp(`Schedule\\s+(\\d+)$`, "i");
export const nbspRegex = /&nbsp;/gi;
export const spaceRegex = /\s+/g;